import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useQuery } from '@tanstack/react-query'

import useTrapSpiderfy from '@App/hooks/useTrapSpiderfy'
import { fetchSampleLocationsByMission } from '@services/data.service'

function Traps({ map, smartTrapFilterIds = [] }) {
  const { activeProject } = useSelector(state => state.missionSetup)

  const { data: sampleLocations } = useQuery({
    queryKey: ['sampleLocations', activeProject?.id],
    queryFn: () => fetchSampleLocationsByMission(activeProject?.id),
    enabled: !!activeProject?.id,
  })

  useEffect(() => {
    if (!map) return

    const canvasContainer = document.querySelector('.maplibregl-canvas')
    if (!canvasContainer) return

    const onMouseMove = (e) => {
      const features = map.queryRenderedFeatures(e.point, { layers: ['trap-layer'] })
      const isCluster = features.some(f => f.properties && f.properties.cluster)
      if (isCluster) {
        canvasContainer.classList.add('pointer-cursor')
      } else {
        canvasContainer.classList.remove('pointer-cursor')
      }
    }

    const onMouseLeave = () => {
      canvasContainer.classList.remove('pointer-cursor')
    }

    map.on('mousemove', 'trap-layer', onMouseMove)
    map.on('mouseleave', 'trap-layer', onMouseLeave)

    return () => {
      map.off('mousemove', 'trap-layer', onMouseMove)
      map.off('mouseleave', 'trap-layer', onMouseLeave)
      canvasContainer.classList.remove('pointer-cursor')
    }
  }, [map])

  useTrapSpiderfy({ map })

  useEffect(() => {
    if (map && sampleLocations) {
      const features = sampleLocations.filter(sampleLocation => smartTrapFilterIds.includes(sampleLocation.status))

      const geojsonData = {
        type: 'FeatureCollection',
        features: features.map((sampleLocation) => {
          const { geometry, properties, status } = sampleLocation
          return {
            type: 'Feature',
            properties: {
              ...properties,
              status,
              trapId: properties?.locationKey || properties?.client_name,
              name: properties?.client_name,
            },
            geometry,
          }
        }),
      }

      const source = map.getSource('traps')
      if (source) source.setData(geojsonData)
    }

    return () => {
      const source = map?.getSource('traps')
      if (source) {
        source.setData({
          type: 'FeatureCollection',
          features: [],
        })
      }
    }
  }, [map, sampleLocations, smartTrapFilterIds])

  return null
}

export default Traps
